<template>
  <div>

    <div class="joinbx text-center" v-if="showtitle">

      <div class="row" v-bind:class="customClass">
        <div class="col-3 text-center">
          <a href="https://www.facebook.com/SouledStore" aria-label="Facebook" rel="noopener noreferrer" target="_blank" class="nonecolor" @click="facebookClick">
            <div class="circle-icon fbook" v-bind:class="sizeicon"><span class="fa fa-facebook"></span></div>
            <small>Facebook  </small>
          </a>
        </div>
        <div class="col-3">
          <a href="https://www.instagram.com/TheSouledStore/" aria-label="Instagram" rel="noopener noreferrer" target="_blank" class="nonecolor"  @click="instagramClick">
            <div class="circle-icon instagram" v-bind:class="sizeicon"><span class="fa fa-instagram"></span></div>
            <small>Instagram</small>
          </a>
        </div>
         <div class="col-3" v-if="callerComp==='contact-us'">
          <a href="https://www.youtube.com/channel/UC1LkdB8GTrMEwFF_yzqytoA" aria-label="Youtube" rel="noopener noreferrer" target="_blank" class="nonecolor"  @click="snapchatClick">
            <div class="circle-icon youtube" v-bind:class="sizeicon"><span class="fa fa-youtube"></span></div>
            <small>Youtube</small>
          </a>
        </div>
        <div class="col-3" v-else>
          <a href="https://www.snapchat.com/add/thesouledstore" rel="noopener noreferrer" aria-label="Snapchat" target="_blank" class="nonecolor"  @click="snapchatClick">
            <div class="circle-icon snapchat" v-bind:class="sizeicon"><span class="fa fa-snapchat"></span></div>
            <small>Snapchat</small>
          </a>
        </div>
        <div class="col-3">
          <a href="https://twitter.com/TheSouledStore" rel="noopener noreferrer" aria-label="Twitter" target="_blank" class="nonecolor "  @click="twitterClick">
            <div class="circle-icon  x-twitter" v-bind:class="sizeicon"><span class="fa fa-twitter"></span></div>
            <small>X</small>
          </a>
        </div>
      </div>
    </div>
    <div class="joinbx text-center" v-else>
      <a href="https://www.facebook.com/SouledStore" aria-label="Facebook" target="_blank" rel="noopener noreferrer" class="nonecolor circle-icon fbook "
         v-bind:class="sizeicon"><span class="fa fa-facebook" @click="facebookClick"></span></a>
      <a href="https://www.instagram.com/TheSouledStore/" aria-label="Instagram" target="_blank" rel="noopener noreferrer"
         class="nonecolor circle-icon instagram " v-bind:class="sizeicon" @click="instagramClick"><span class="fa fa-instagram"></span></a>
      <a href="https://www.snapchat.com/add/thesouledstore" aria-label="Snapchat" target="_blank" rel="noopener noreferrer"
         class="nonecolor circle-icon snapchat " v-bind:class="sizeicon" @click="snapchatClick"><span class="fa fa-snapchat"></span></a>
      <a href="https://twitter.com/TheSouledStore" aria-label="X" target="_blank" rel="noopener noreferrer" class="nonecolor circle-icon x-twitter "
         v-bind:class="sizeicon" @click="twitterClick"><span class="fa fa-twitter"></span></a>
    </div>
  </div>
</template>
<script>
  import {mapGetters} from 'vuex'
  export default {
    props: ['sizeicon', 'showtitle', 'customClass', 'callerComp'],
    methods: {
      facebookClick () {
        this.trackEvent('facebook')
        this.$store.commit('GTAG_EVENT', {eventName: 'facebook', payload: {}})
        // this.callerComp === 'footer' ? this.$store.dispatch('TATVIC_EVENT', {eventName: 'FOOTER_OPTIONS',
        //   payload: {
        //     FOOTER_LINK_TEXT: 'Facebook'
        //   }
        // }) : ''
        this.callerComp === 'footer' ? this.$store.dispatch('TATVIC_EVENT', {eventName: 'SOCIAL_MEDIA_CLICKS',
          payload: {
            MEDIUM: 'Facebook'
          }
        }) : ''
      },
      instagramClick () {
        this.trackEvent('instagram')
        this.$store.commit('GTAG_EVENT', {eventName: 'instagram', payload: {}})
        // this.callerComp === 'footer' ? this.$store.dispatch('TATVIC_EVENT', {eventName: 'FOOTER_OPTIONS',
        //   payload: {
        //     FOOTER_LINK_TEXT: 'Instagram'
        //   }
        // }) : ''
        this.callerComp === 'footer' ? this.$store.dispatch('TATVIC_EVENT', {eventName: 'SOCIAL_MEDIA_CLICKS',
          payload: {
            MEDIUM: 'Instagram'
          }
        }) : ''
      },
      snapchatClick () {
        this.trackEvent('snapchat')
        this.$store.commit('GTM_SNAPCHAT_CLICK')
        // this.callerComp === 'footer' ? this.$store.dispatch('TATVIC_EVENT', {eventName: 'FOOTER_OPTIONS',
        //   payload: {
        //     FOOTER_LINK_TEXT: 'Snapchat'
        //   }
        // }) : ''
        this.callerComp === 'footer' ? this.$store.dispatch('TATVIC_EVENT', {eventName: 'SOCIAL_MEDIA_CLICKS',
          payload: {
            MEDIUM: 'Snapchat'
          }
        }) : ''
      },
      twitterClick () {
        this.trackEvent('twitter')
        this.$store.commit('GTAG_EVENT', {eventName: 'twitter', payload: {}})
        // this.callerComp === 'footer' ? this.$store.dispatch('TATVIC_EVENT', {eventName: 'FOOTER_OPTIONS',
        //   payload: {
        //     FOOTER_LINK_TEXT: 'Twitter'
        //   }
        // }) : ''
        this.callerComp === 'footer' ? this.$store.dispatch('TATVIC_EVENT', {eventName: 'SOCIAL_MEDIA_CLICKS',
          payload: {
            MEDIUM: 'Twitter'
          }
        }) : ''
      },
      trackEvent (platform) {
        this.$store.commit('MOENGAGE_EVENT', {eventName: 'TRACK_CONTACT_US_SOCIAL_IMAGE_CLICK',
          payload: {
            Redirection_Platform: platform,
            UserId: this.user && this.user.user_id,
            DateTime: new Date() && new Date().toISOString(),
            Platform: 'WEB'
          }}
        )
      }
    },
    computed: {
      ...mapGetters(['user'])
    }
}
</script>
<style scoped>
  .shareicon {
  }

  .shareicon .circle-icon {
    width: 35px;
    height: 35px;
    font-size: 18px;
    line-height: 35px;
    float: left;
    margin: 0 5px;
  }

  .joinbx {
    padding-top: 0px;
  }

  .joinbx a {
    display: inline-block;
    margin: 0px 2px;
  }

  .joinbx .circle-icon.small {
    width: 35px;
    height: 35px;
    font-size: 18px;
    line-height: 35px;
  }

  .joinbx .circle-icon.medium {
    width: 50px;
    height: 50px;
    line-height: 50px;
    font-size: 25px;
  }

  .shareicon .circle-icon a {
    color: #fff;
  }

  .wdhome small {
    font-size: 80%;
    font-weight: normal;
    text-transform: inherit;
    font-family: 'Source Sans Pro', sans-serif;
font-weight: 400;
  }

  @media screen and (max-width: 991px) {
    .joinbx .circle-icon.medium {
      width: 35px;
      height: 35px;
      line-height: 35px;
      font-size: 18px;
    }
  }

  .fa.fa-twitter::before{
	content:"𝕏";
	font-size:1em;
  color: #fff;
  }

  .x-twitter{
  background: black;
}
</style>



// WEBPACK FOOTER //
// followsWithsocial.vue?649c3c06